import { UserService } from '@/api/services/userService';
import { InvoiceService } from '@/api/services/invoiceService';
import { TaxpayerService } from '@/api/services/taxpayerService';

export default {
  user: new UserService(),
  invoice: new InvoiceService(),
  taxpayer: new TaxpayerService(),
};
